import React from 'react';
import { CBackdrop, CSpinner } from '@coreui/react';

function LoadingOverlay({ isLoading, loadingMessage }) {
  return (
    <CBackdrop
      data-testid="backdrop"
      visible={isLoading}
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex flex-column align-items-center justify-content-center"
      style={{ zIndex: 1200 }}
    >
      <CSpinner color="light" />
      {loadingMessage && (
        <div className="text-white fs-5 mt-3 text-center">
          {loadingMessage}
        </div>
      )}
    </CBackdrop>
  );
}

export default LoadingOverlay;
